<template>
  <div class="contact">
    <sectionImage section="contact" :text="header"></sectionImage>
    <b-container>
      <sectionHeader :text="secondHeader" />
      <b-row class="justify-content-md-center info">
        <b-col sm="12" md="4">
          <li v-for="(item, i) in addressList" :key="i" style="border:none; list-style-type: none">
            <a v-if="item.isLink" :href="item.link" style="font-weight: 300;color:black;">{{item.text}}</a>
            <a v-else>{{item.text}} {{item.bold}}</a>
          </li>
        </b-col>
      </b-row>

      <b-row class="mb-4">
        <iframe src="https://www.google.com/maps/d/embed?mid=1jhviqhPB8vXA4ajQOnQBdy6ELRuz4DQ" width="100%" height="400"></iframe>
      </b-row>

    </b-container>
  </div>
</template>

<script>
import sectionImage from '../SectionImage'
import sectionHeader from '../text/SectionHeader'

const SECTIONID = 10

export default {
  name: 'contact',
  props: ['language'],
  components: {
    sectionImage,
    sectionHeader,
  },
  data () {
    return {
      header: '',
      secondHeader: '',
      addressList: [],
    }
  },
  watch: {
    language: function () {
      this.handleLanguage()
    }
  },
  created: function () {
    this.handleLanguage()
  },
  methods: {
    handleLanguage: function () {
      this.header = this.$root.getHeader(3)
      this.secondHeader = this.$root.getHeader(SECTIONID)
      this.addressList = this.$root.getCategoryList(SECTIONID, 0)
    }
  }
}
</script>

<style scoped>

.info {
  padding: 10px;
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/contact/Contact.vue